/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const useUserContext = () => {
  return useContext(UserContext);
};

const UserProvider = ({ children }) => {
  const [userContext, setUserContext] = useState(JSON.parse(localStorage.getItem('UserData')));

  const values = {
    userContext,
    setUserContext
  };
  return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
};

export default UserProvider;
